import React, { useState } from 'react'
import Modal from 'react-modal'
import moment from 'moment'

import closeIcon from '../../assets/icons/close.svg'
import calendarIcon from '../../assets/icons/Calendar.svg'
import timeConvert from '../../utils/formatTime.js'

import '../../styles/scss/base/modal.scss'
import '../../styles/scss/base/table.scss'
import '../../styles/scss/components/equote-package-itinerary-modal.scss'
import triggerCustomGaEvent from '../../utils/triggerCustomGaEvent'

const _ = require('lodash')

const calculateCruiseDates = (day, sailDate) => {
  return moment(sailDate, 'YYYY-MM-DD')
    .add(day - 1, 'days')
    .format('MMMM DD, YYYY')
}

const renderTableItinerary = (props, array, title) => {
  return (
    props.itinerary && (
      <>
        <h2>{title}</h2>
        <div className="u-overflow-x-scroll">
          <table className="u-table">
            <thead>
              <tr>
                <th>Day</th>
                <th>Port City</th>
                <th>Activity</th>
                <th>Arrival</th>
                <th>Departure</th>
              </tr>
            </thead>
            <tbody>
              {array.map(
                ({ day, activity, departureTime, arrivalTime, name }, i) => (
                  <tr key={i}>
                    <td className="center">
                      {calculateCruiseDates(day, props.startDate)}
                    </td>
                    <td>{name}</td>
                    <td className="center">{activity ? activity : '-'}</td>
                    <td className="center">
                      {arrivalTime ? timeConvert(arrivalTime) : '-'}
                    </td>
                    <td className="center">
                      {departureTime ? timeConvert(departureTime) : '-'}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </>
    )
  )
}

const renderTableTour = (props, array, title) => {
  return (
    props.itinerary && (
      <>
        <h2>{title}</h2>
        <table className="u-table">
          <thead>
            <tr>
              <th>Day</th>
              <th>Port City</th>
              <th>Activity</th>
            </tr>
          </thead>
          <tbody>
            {array.map(({ day, activity, name }, i) => (
              <tr key={i}>
                <td className="center">
                  {calculateCruiseDates(day, props.startDate)}
                </td>
                <td>{name}</td>
                <td className="center">
                  {activity
                    ? activity === 'Cruisetour'
                      ? 'Cruisetour'
                      : activity
                    : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    )
  )
}

const renderTableSailing = props => {
  let { itinerary } = props
  itinerary = itinerary.filter(day => day.activity !== 'Cruisetour')
  return renderTableItinerary(props, itinerary, 'Sailing Itinerary')
}

const renderTablePreSailing = props => {
  const { itinerary, cruiseTourDetails } = props
  if (!itinerary || !itinerary.length || !cruiseTourDetails) return null
  const { embarkDay } = cruiseTourDetails

  const preSailing = itinerary.filter(day => {
    return day.activity === 'Cruisetour' && Number(day.day) <= Number(embarkDay)
  })
  if (preSailing && preSailing.length) {
    return renderTableTour(props, preSailing, 'Pre-Sailing Tour')
  }
}

const renderTablePostSailing = props => {
  const { itinerary, cruiseTourDetails } = props
  if (!itinerary || !itinerary.length || !cruiseTourDetails) return null
  const { embarkDay } = cruiseTourDetails
  const postSailing = itinerary.filter(day => {
    return day.activity === 'Cruisetour' && Number(day.day) > Number(embarkDay)
  })

  if (postSailing && postSailing.length) {
    return renderTableTour(props, postSailing, 'Post-Sailing Tour')
  }
}

const renderLandProgramTable = (program, startDate) => {
  const { title, itinerary, description } = program
  return (
    <>
      <h2>{title}</h2>
      <p>{description}</p>
      <table className="u-table">
        <thead>
          <tr>
            <th style={{ minWidth: '148px' }}>Day</th>
            <th style={{ minWidth: '148px' }}>City</th>
            <th>Activity</th>
          </tr>
        </thead>
        <tbody>
          {itinerary &&
            itinerary.length &&
            itinerary.map(day => (
              <tr key={day['field_day']}>
                <td className="center">
                  {calculateCruiseDates(day['field_day'], startDate)}
                </td>
                <td>{day['field_title']}</td>
                <td>{day['field_description']}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  )
}

const renderModalContent = (props, setModalOpened) => {
  const { itinerary, landPrograms } = props

  if (!_.isEmpty(itinerary)) {
    return (
      <div className="equote__package-itinerary-modal">
        <div className="u-modal__header">
          <div
            className="u-modal__close"
            onClick={() => setModalOpened(false)}
            tabIndex={0}
          >
            Close{' '}
            <img
              className="u-modal__close-icon"
              src={closeIcon}
              alt="eQuote Ship Modal Close"
            />
          </div>
        </div>

        <div className="u-modal__body">
          <div className="equote__package-itinerary-modal-content">
            {renderTablePreSailing(props)}
            {landPrograms && landPrograms.pre
              ? renderLandProgramTable(landPrograms.pre, props.startDate)
              : null}
            {renderTableSailing(props)}
            {landPrograms && landPrograms.post
              ? renderLandProgramTable(landPrograms.post, props.startDate)
              : null}
            {renderTablePostSailing(props)}
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <p className="error-message">
        There appears to be no data for this itinerary - please check back
      </p>
    )
  }
}

export default function EQuotePackageItineraryModal(props) {
  const { contentLabel } = props
  const [modalVisible, setModalOpened] = useState(false)

  return (
    <>
      <div
        onClick={() => {
          setModalOpened(true)
          triggerCustomGaEvent('sailingPreview-viewItinerary', true)
        }}
        className="equote-preview-package-itinerary--header--link"
      >
        <img
          className="u-modal__calendar-icon"
          src={calendarIcon}
          alt="eQuote calendar icon"
        />{' '}
        View At-A-Glance Itinerary
      </div>
      {modalVisible && (
        <Modal
          className={{
            base: 'u-modal',
            afterOpen: 'u-modal--visible',
            beforeClose: 'u-modal--close',
            ariaHideApp: false
          }}
          overlayClassName={{
            base: 'u-fade',
            afterOpen: 'u-fade--visible',
            beforeClose: 'u-fade--visible'
          }}
          isOpen={modalVisible}
          onRequestClose={() => {
            setModalOpened(false)
          }}
          contentLabel={contentLabel}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
          htmlOpenClassName="ReactModal__Html--open"
        >
          {renderModalContent(props, setModalOpened)}
        </Modal>
      )}
    </>
  )
}
